/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { Method,prepare,QueryStringArrayFormat,RequestBodyType,ResponseBodyType } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig,RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from './request';
// @ts-ignore
import makeRequestHook from './makeRequestHook';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult,
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (
      requestData: TRequestData,
      ...args: RequestFunctionRestArgs<typeof request>
    ) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://yapi.yishou.com/mock/187' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = '' as any;
const dataKey_0_0_0_0 = 'data' as any;

export interface AddRequest {
  /**
   * 排序值,值越大，排越前
   */
  sort?: string;
  /**
   * 属性值
   */
  value: string;
}

export interface AddResponse {
  /**
   * 属性值
   */
  attrName?: string;
  /**
   * 属性类型
   */
  attrType?: 'COLOUR' | 'SIZE' | 'TYPE' | 'OVERHEAD_PAY' | 'OVERHEAD_IN';
  /**
   * 启用/禁用
   */
  enabled?: boolean;
  /**
   * 属性ID
   */
  id?: number;
  /**
   * 店铺ID
   */
  shopId?: number;
  /**
   * 排序值
   */
  sort?: number;
}

type AddRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/187',
    '',
    '',
    '/manage/shop/size/add',
    'data',
    string,
    'sort' | 'value',
    false
  >
>;

const addRequestConfig: AddRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/manage/shop/size/add',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['sort', 'value'],
  requestDataOptional: false,
  requestDataJsonSchema: {
    type: 'object',
    required: ['value'],
    properties: {
      sort: { type: 'string', description: '排序值,值越大，排越前' },
      value: { type: 'string', description: '属性值' },
    },
  },
  responseDataJsonSchema: {
    type: 'object',
    properties: {
      attrName: { type: 'string', description: '属性值' },
      attrType: {
        type: 'string',
        description: '属性类型',
        enum: ['COLOUR', 'SIZE', 'TYPE', 'OVERHEAD_PAY', 'OVERHEAD_IN'],
      },
      enabled: { type: 'boolean', description: '启用/禁用' },
      id: { type: 'integer', format: 'int32', description: '属性ID' },
      shopId: { type: 'integer', format: 'int32', description: '店铺ID' },
      sort: { type: 'integer', format: 'int32', description: '排序值' },
    },
    title: 'ShopAttrDto',
  },
  requestFunctionName: 'add',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

export const add = /*#__PURE__*/ (requestData: AddRequest, ...args: UserRequestRestArgs) => {
  return request<AddResponse>(prepare(addRequestConfig, requestData), ...args);
};

add.requestConfig = addRequestConfig;

export const useAdd = /*#__PURE__*/ makeRequestHook<
  AddRequest,
  AddRequestConfig,
  ReturnType<typeof add>
>(add);

export interface ListRequest {}

export interface ListResponse {
  list?: {
    /**
     * 属性值
     */
    attrName?: string;
    /**
     * 属性类型
     */
    attrType?: 'COLOUR' | 'SIZE' | 'TYPE' | 'OVERHEAD_PAY' | 'OVERHEAD_IN';
    /**
     * 启用/禁用
     */
    enabled?: boolean;
    /**
     * 属性ID
     */
    id?: number;
    /**
     * 店铺ID
     */
    shopId?: number;
    /**
     * 排序值
     */
    sort?: number;
  }[];
  shopId?: number;
  shopName?: string;
}

type ListRequestConfig = Readonly<
  RequestConfig<
    'http://yapi.yishou.com/mock/187',
    '',
    '',
    '/manage/shop/size/list',
    'data',
    string,
    string,
    true
  >
>;

const listRequestConfig: ListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/manage/shop/size/list',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {
    type: 'object',
    properties: {
      list: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            attrName: { type: 'string', description: '属性值' },
            attrType: {
              type: 'string',
              description: '属性类型',
              enum: ['COLOUR', 'SIZE', 'TYPE', 'OVERHEAD_PAY', 'OVERHEAD_IN'],
            },
            enabled: { type: 'boolean', description: '启用/禁用' },
            id: { type: 'integer', format: 'int32', description: '属性ID' },
            shopId: { type: 'integer', format: 'int32', description: '店铺ID' },
            sort: { type: 'integer', format: 'int32', description: '排序值' },
          },
          title: 'ShopAttrDto',
        },
      },
      shopId: { type: 'integer', format: 'int32' },
      shopName: { type: 'string' },
    },
    title: 'ShopAttributes',
  },
  requestFunctionName: 'list',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

export const list = /*#__PURE__*/ (requestData?: ListRequest, ...args: UserRequestRestArgs) => {
  return request<ListResponse>(prepare(listRequestConfig, requestData), ...args);
};

list.requestConfig = listRequestConfig;

export const useList = /*#__PURE__*/ makeRequestHook<
  ListRequest,
  ListRequestConfig,
  ReturnType<typeof list>
>(list);

/* prettier-ignore-end */
